// Row-major build slots and unit orders share the grid in separate flyout contexts.
const gridOrders = {
  attack: "r",
  stop: "t",
  guard: "y",
  patrol: "f",
  holdPosition: "g",
  formationShape: "h",
  holdFire: "v",
  unload: "b",
  more: "n",
};
export const keymap = {
  camera: {
    pan: {
      up: ["w", "arrowup"],
      left: ["a", "arrowleft"],
      down: ["s", "arrowdown"],
      right: ["d", "arrowright"],
    },
    rotate: { left: ["["], right: ["]"] },
    reset: "home",
  },
  cinematic: {
    rotate: { left: ["q", "["], right: ["e", "]"] },
    toggle: "F9",
    exit: "escape",
    play: " ",
    clear: "backspace",
    frame: "v",
    rate: "t",
    tiltUp: "r",
    tiltDown: "f",
    slots: ["1", "2", "3", "4", "5"],
  },
  // "]" rotates the camera, so stepping uses the free backslash key.
  sandbox: { toggle: "`", step: "\\", remove: "Delete" },
  strike: { missile: "F1", bomber: "F2", drone: "F3", recon: "F4" },
  categories: { base: "q", defence: "e", infantry: "z", vehicles: "x", air: "c" },
  grid: {
    slots: Object.values(gridOrders),
    ...gridOrders,
  },
  building: { upgrade: "u", rally: "j", sell: "l", repair: "k" }, // Repair reserved; no sim command.
  global: {
    cancel: "Escape",
    alert: " ",
    idleBuilder: ".",
    minimap: "m",
    details: "Alt",
    ping: "p",
    chat: "Enter",
    // Display and first-empty allocation order; each number is also its shortcut.
    groups: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
  },
  modifiers: { queue: "Shift", bindGroup: "Control" },
  trackpad: {
    // O and comma/semicolon leave gameplay letters free; Shift still appends selections.
    keys: ["o", ",", ";"],
    bindings: { box: "o", army: ",", type: ";" },
  },
  // Native form/menu navigation is separate from gameplay shortcuts.
  navigation: {
    up: "ArrowUp",
    down: "ArrowDown",
    left: "ArrowLeft",
    right: "ArrowRight",
    first: "Home",
    last: "End",
    erase: "Backspace",
    confirm: "Enter",
    next: "Tab",
    contextMenu: "ContextMenu",
    contextMenuAlternate: "F10",
  },
  debug: { stats: "F8", quality: "F7" },
};
